// Fail-closed export receipt: the server logs every export (docs/AUDIT-TRAIL.md) before the browser
// builds a file. No 2xx from the server, no file.
import { api } from "./api";

export interface ExportReceipt {
  resource_type: "loan";
  item_ids: string[];
  format: "xlsx";
}

export type Poster = (path: string, init: { method: string; body: unknown }) => Promise<unknown>;

/** Records the export, then runs `build`. If recording fails, `build` never runs and the error propagates. */
export async function withExportReceipt<T>(receipt: ExportReceipt, build: () => Promise<T>, post: Poster = api): Promise<T> {
  await post("/api/audit/export-receipt", { method: "POST", body: receipt });
  return build();
}
